// Career started as a Trainee at Boscosoft Technologies in March 2021.
export const CAREER_START = {year: 2021, month: 3};

const NUMBER_WORDS = [
    'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
    'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen',
];

// Full years elapsed since CAREER_START, so the site never goes stale.
export function yearsOfExperience(now = new Date()) {
    const months = (now.getFullYear() - CAREER_START.year) * 12
        + (now.getMonth() + 1 - CAREER_START.month);

    return Math.max(0, Math.floor(months / 12));
}

// e.g. "over five years"
export function experienceInWords(now = new Date()) {
    const years = yearsOfExperience(now);
    const word = NUMBER_WORDS[years] ?? String(years);

    if (years === 0) return 'under a year';

    return years === 1 ? 'over one year' : `over ${word} years`;
}
